import apiVersion from '../_helpers/api-version';
import axiosInstance from '../_helpers/axiosConfig'

import { store } from '../_helpers/store';
import { authHeader } from '../_helpers/auth-header'
import httpStatus from 'http-status';

export const doctorService = {
  getAll,
  getLandings,
  enableLanding,
  updateLanding,
  getLandingById,
  enableLandingById,
  updateLandingById
};

function getLandings() {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/landing-page`,
    headers: authHeader(),
    method: 'GET'
  }).then((response) => {
    return response.data;
  });
}

function getLandingById(id) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/landing-page/${id}`,
    headers: authHeader(),
    method: 'GET'
  }).then((response) => {
    return response.data;
  });
}

function updateLanding(content) {
  return axiosInstance.request({
    method: 'PATCH',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/landing-page`,
    data: { content }
  }).then((response) => {
    return response.data;
  })
}

function updateLandingById(id, content) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'PATCH',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/landing-page/${id}`,
    data: { content }
  }).then((response) => {
    return response.data;
  })
}

function enableLanding(content, domain) {
  return axiosInstance.request({
    method: 'POST',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/landing-page`,
    data: { content, domain }
  }).then((response) => {
    return response.data;
  })
}

function enableLandingById(licensedId, content, domain) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'POST',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/landing-page`,
    data: { licensedId, content, domain }
  }).then((response) => {
    return response.data;
  })
}

function getAll() {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'GET',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/doctor`,
  }).then((response) => {
    if (response && response.status === httpStatus.OK) {
      return response.data.data;
    }
  })
}